/**
 * PJD-001 Task 11 — Document Grace watchlist API client.
 *
 * Backend service: app/api/routers/hr_doc_grace.py (mounted at /api/v1/hr/doc-grace).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/shared/api/client'

export interface DocGraceRow {
  id: string
  employee_id: string
  emp_code: string | null
  emp_name: string | null
  stage: string
  required_doc_group: string
  join_ref_date: string
  deadline_date: string
  inactivate_date: string
  days_to_deadline: number
  withheld_days: number
  cleared_doc_type: string | null
}

export function useDocGrace(plantId?: string, stage?: string) {
  return useQuery({
    queryKey: ['doc-grace', plantId, stage],
    queryFn: async () =>
      (
        await apiClient.get<DocGraceRow[]>('/hr/doc-grace', {
          params: { plant_id: plantId, stage },
        })
      ).data,
  })
}

export function useCancelDocGrace() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (v: { id: string; reason: string }) =>
      (await apiClient.post(`/hr/doc-grace/${v.id}/cancel`, { reason: v.reason })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['doc-grace'] }),
  })
}

export function useProvisionalActivate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (v: { employee_id: string; checklist_item_id: string; remarks?: string }) =>
      (await apiClient.post('/hr/doc-grace/provisional-activate', v)).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['doc-grace'] })
      qc.invalidateQueries({ queryKey: ['joining-detail'] })
    },
  })
}
